// extracted by mini-css-extract-plugin
module.exports = {"container":"OzsCnZ0H","metadataText":"mOT3LeYN"};